import { ReactNode } from 'react';

/**
 * Chat Data
 */
export enum MessageType {
  BOT = 'bot',
  BOT_GENERATING = 'bot_generating',
  USER = 'user',
  DESIGN = 'design',
  SUGGESTION = 'suggestion',
  BUTTON = 'button',
}

export type ChatData = {
  type: MessageType;
  messages: string[];
  children?: ReactNode;
  createdAt: number;
};

export type ChatConfig = {
  [MessageType.BOT_GENERATING]: {
    delayPerLine: number;
    typeSpeed: number;
    loadingDotTypeSpeed: number;
  };
};

export type PanelActionCallback = (type: MessageType, payload: string, chatData: ChatData) => void;
export type InputSubmitCallback = (userMessage: string) => void;

/**
 * Component Props
 */
export type ChatTypeProps = {
  chatDataList: ChatData[];
  isDisabled?: boolean;
  config?: ChatConfig;
  onUpdate?: PanelActionCallback;
  onSubmit?: InputSubmitCallback;
};

export type ChatInputProps = {
  onSubmit: InputSubmitCallback;
  isDisabled?: boolean;
  placeholder?: string;
};

export type ChatPanelProps = {
  messages: ChatData[];
  isDisabled?: boolean;
  autoScrollToBottom?: boolean;
  config: ChatConfig;
  onUpdate?: PanelActionCallback;
};

export type MessageComponentProps = {
  children?: React.ReactNode;
  data: ChatData;
  index: number;
  isDisabled: boolean;
  config: ChatConfig;
  onUpdate: PanelActionCallback;
};

export type BotMessageProps = {
  data: ChatData;
  index: number;
};

export type DesignMessageProps = {
  data: ChatData;
  index: number;
  isDisabled?: boolean;
  onUpdate: PanelActionCallback;
};

export type GeneratingMessageProps = {
  data: ChatData;
  config: ChatConfig;
  onUpdate: PanelActionCallback;
};

export type SuggestionMessageProps = {
  data: ChatData;
  isDisabled?: boolean;
  onUpdate: PanelActionCallback;
};

export type UserMessageProps = {
  data: ChatData;
};

export type ButtonMessageProps = {
  data: ChatData;
  isDisabled?: boolean;
  onUpdate: PanelActionCallback;
};
